import React from 'react';

import { UploadNavItem } from '~/backup/shared/components/UploadNavItem';
import { Icon } from '~/packages/common-frontend/components/icons';
import {
  GlobalNav,
  GlobalNavRouterLinkItem,
} from '~/packages/common-frontend/layout';

export const BackupOriginatorGlobalNav = ({
  isFixed = true,
}: {
  isFixed?: boolean;
}): React.ReactElement => {
  return (
    <GlobalNav isFixed={isFixed} offsetHeaderCount={1}>
      <UploadNavItem />
      <GlobalNavRouterLinkItem
        to="/data-pipeline"
        label="Data Pipeline"
        icon={<Icon icon="share-nodes" />}
      />
    </GlobalNav>
  );
};
